const wasmURL = 'https://unpkg.com/vmsg@0.3.0/vmsg.wasm';

export default wasmURL;
